var map = {
	".": "365c",
	"./": "365c",
	"./commodity": "11c8",
	"./commodity/": "11c8",
	"./commodity/customProduct": "d427",
	"./commodity/customProduct.js": "d427",
	"./commodity/index": "11c8",
	"./commodity/index.js": "11c8",
	"./common": "b26e",
	"./common/": "b26e",
	"./common/40seas": "9c2b",
	"./common/40seas.js": "9c2b",
	"./common/ai": "2e95",
	"./common/ai.js": "2e95",
	"./common/dataEmbeddingPoint": "e80c",
	"./common/dataEmbeddingPoint.js": "e80c",
	"./common/index": "b26e",
	"./common/index.js": "b26e",
	"./common/pod": "de8c",
	"./common/pod.js": "de8c",
	"./common/selectData": "3123",
	"./common/selectData.js": "3123",
	"./index": "365c",
	"./index.js": "365c",
	"./index/": "2400",
	"./index/album": "26b2",
	"./index/album.js": "26b2",
	"./index/discount": "95c2",
	"./index/discount.js": "95c2",
	"./index/index": "2400",
	"./index/index.js": "2400",
	"./order/list": "0bbe",
	"./order/list.js": "0bbe",
	"./order/sales": "cfd5",
	"./order/sales.js": "cfd5",
	"./order/service": "2680",
	"./order/service.js": "2680",
	"./personal/certification": "bb3a",
	"./personal/certification.js": "bb3a",
	"./personal/home": "cfa1",
	"./personal/home.js": "cfa1",
	"./personal/login": "430f",
	"./personal/login.js": "430f",
	"./personal/newFunction": "4d19",
	"./personal/newFunction.js": "4d19",
	"./personal/payment": "b9b6",
	"./personal/payment.js": "b9b6",
	"./personal/store": "0bc8",
	"./personal/store.js": "0bc8",
	"./publish/Woocommerce": "e0fa",
	"./publish/Woocommerce.js": "e0fa",
	"./publish/listings": "5355",
	"./publish/listings.js": "5355",
	"./publish/shoplazza": "77ba",
	"./publish/shoplazza.js": "77ba",
	"./publish/shopline": "d685",
	"./publish/shopline.js": "d685",
	"./publish/temu": "b99f",
	"./publish/temu.js": "b99f",
	"./publish/tiktok": "e19c",
	"./publish/tiktok.js": "e19c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a8f";